import { MatDialogModule } from '@angular/material/dialog';
import { FORM_MANAGER_REDUCER_TOKEN, getReducers } from '@nrwl/rx-state-reducers';
import { DiagnosisTreatmentsModule } from '@nrwl/rx-state-diagnosis-treatments';
import { DoctorTokenInterceptor } from './doctor/core/doctor-token.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RxIdleUserModule, RxIdleUserWatchService } from '@nrwl/rx-idle-user';
import { Auth_REDUCER_TOKEN, getAuthReducers } from '@nrwl/rx-photo-state';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
// import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { ClientPhotosModule } from './client-photos/client-photos.module';
import { RouterModule as RxRouterModule } from '@nrwl/rx-service-router';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { DatePipesModule } from '@nrwl/date-pipes';
import { TokenInterceptor } from '@nrwl/rx-service-auth'; // dont touch =)
import { AdministrationModule } from './admin/administration.module';
import { APP_BASE_HREF, CommonModule, PlatformLocation } from '@angular/common';
import { AppDndDirective } from './directives/app-dnd.directive';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { AngularMaterialModule } from '@nrwl/angular-material';
import { SentryHandlerService } from '@nrwl/rx-service-sentry';
import { RxImgCompositeModule } from '@nrwl/rx-img-preview';
import { ContentStoreModule } from '@nrwl/rx-state-content';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { RxFormDesignerModule } from '@nrwl/rx-form-designer';
import { RxFormsModule } from '@nrwl/rx-form-components';
import { EditorModule } from '@tinymce/tinymce-angular';
import { AppRoutingModule } from './app-routing.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
// import { RootStoreModule } from '@nrwl/rx-root-state';
import { CookieService } from 'ngx-cookie-service';
import { RxSpinnerModule } from '@nrwl/rx-spinner';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { RxDialogModule } from '@nrwl/rx-dialog';
import { RxNavBarModule } from '@nrwl/rx-navbar';
import { environment } from '@nrwl/environment';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { RxIconModule } from '@nrwl/rx-icon';
import { StoreModule } from '@ngrx/store';
// import { AvatarModule } from 'ngx-avatar'; // WARNING: MIGRATION
import { RxUiModule } from '@nrwl/rx-ui';
import {
  ROUTER_REDUCER_TOKEN,
  RxManagerEffectsModules,
  SPINNER_REDUCER_TOKEN,
  getRouterReducer,
  getSpinnerReducer,
} from '@nrwl/rx-user';
import {
  RxBottomBarCompositeModule,
  RxFileUploadModule,
  RxFormsBrowserModule,
  RxListCompositeModule,
  RxNewGroupCompositeModule,
  RxPasswordFormModule,
  RxReactiveFormCompositeModule,
  RxTextCompositeModule,
  RxUploadPaidCompositeModule,
  RxUploadZoneModule,
  RxVideoCompositeModule,
} from '@nrwl/rx-components';
import { LogoutComponent } from './core/components/logout/logout.component';
import { RootStoreModule } from '@nrwl/rx-root-state';

@NgModule({
  imports: [
    CommonModule,
    DatePipesModule,
    BrowserAnimationsModule,
    PdfViewerModule,
    DragDropModule,
    AppRoutingModule,
    AdministrationModule,
    MatMomentDateModule,
    EditorModule,
    MatDialogModule,
    // LoadingBarHttpClientModule,
    //AvatarModule,
    ClientPhotosModule,
    // nrwl
    RxFormsBrowserModule,
    RxTextCompositeModule,
    RxListCompositeModule,
    RxTextCompositeModule,
    RxVideoCompositeModule,
    RxReactiveFormCompositeModule,
    RxNewGroupCompositeModule,
    RxUploadPaidCompositeModule,
    RxBottomBarCompositeModule,
    RxUploadZoneModule,
    RxPasswordFormModule,
    RxIconModule,
    RxDialogModule,
    RxUiModule,
    RxFormsModule,
    RxSpinnerModule,
    RxNavBarModule,
    AngularMaterialModule,
    RxIdleUserModule,
    RxFormDesignerModule,

    // new rx-component
    RxImgCompositeModule,
    RxFileUploadModule,

    // ngrx
    StoreRouterConnectingModule.forRoot(),
    RootStoreModule,
    ContentStoreModule,
    DiagnosisTreatmentsModule,
    // StoreModule.forFeature('auth', Auth_REDUCER_TOKEN),
    StoreModule.forFeature('spinner-manager', SPINNER_REDUCER_TOKEN),
    // StoreModule.forFeature('router-manager', ROUTER_REDUCER_TOKEN),
    // StoreModule.forFeature('forms-manager', FORM_MANAGER_REDUCER_TOKEN),
    RxManagerEffectsModules,
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    //AppComponent,
    AppDndDirective,
    LogoutComponent,
  ],
  exports: [AppDndDirective, LogoutComponent],
  providers: [
    RxRouterModule,
    CookieService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DoctorTokenInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: Auth_REDUCER_TOKEN, useFactory: getAuthReducers },
    { provide: SPINNER_REDUCER_TOKEN, useFactory: getSpinnerReducer },
    { provide: ROUTER_REDUCER_TOKEN, useFactory: getRouterReducer },
    {
      provide: FORM_MANAGER_REDUCER_TOKEN,
      useFactory: getReducers,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: function (idleUserWatch: RxIdleUserWatchService) {
        return () => idleUserWatch.init();
      },
      multi: true,
      deps: [RxIdleUserWatchService],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: function (sentryHandler: SentryHandlerService) {
        return () => sentryHandler.init();
      },
      multi: true,
      deps: [SentryHandlerService],
    },
    { provide: ErrorHandler, useClass: SentryHandlerService },
    {
      provide: APP_BASE_HREF,
      useFactory: function getBaseHref(platformLocation: PlatformLocation): string {
        return platformLocation.getBaseHrefFromDOM();
      },
      deps: [PlatformLocation],
    },
  ],
  // Note: No bootstrap property needed in Angular 19 with standalone components
})
export class AppModule {}
